import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const exchange = async () => {
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "X-Session-ID": sessionId ?? "" },
          credentials: "include",
        });
        if (!res.ok) throw new Error("session exchange failed");
        const user = await res.json();
        navigate("/conteudo", { replace: true, state: { user } });
      } catch {
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-black">
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-krono">Autenticando…</span>
    </div>
  );
}
